import { render } from "./DuelsGameRoller.vue?vue&type=template&id=bff8f5e8&scoped=true"
import script from "./DuelsGameRoller.vue?vue&type=script&lang=js"
export * from "./DuelsGameRoller.vue?vue&type=script&lang=js"

import "./DuelsGameRoller.vue?vue&type=style&index=0&id=bff8f5e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bff8f5e8"]])

export default __exports__